<template>
	<div class="wrap">
		<Title title="发起投票"></Title>
		<div class="steps">
			<div class="steps-list" @click="changeSteps(0)" :class="[stepIndex==0?'steps-current':'']">
				<i>1</i>
				<span>投票基本信息</span>
			</div>
			<div class="steps-line"></div>
			<div class="steps-list" @click="changeSteps(1)"  :class="[stepIndex==1?'steps-current':'']">
				<i>2</i>
				<span>设置选手</span>
			</div>
		</div>
		<!--第一步-->
		<div class="step1" v-if="stepIndex==0">
			<el-form :model="formInfo" :rules="rules" ref="ruleForm" label-width="100px" class="add-form">
				<el-form-item label="投票名称" prop="voteName">
					<el-input clearable placeholder="请输入投票名称" v-model="formInfo.voteName"></el-input>
				</el-form-item>
				<el-form-item label="投票封面" prop="poster">
					<el-upload
					:action= uploadUrl
					  list-type="picture-card"
					  :limit="1"
					  :file-list="posterList"
					  :on-success="handleSuccess"
					  :on-preview="handlePictureCardPreview"
					  :on-remove="handleRemove">
					  <i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>
				<div class="upload-tips">图片尺寸建议750*400或等比例尺寸</div>
				<el-form-item label="开始时间" prop="startTime">
					<el-date-picker align="center" v-model="formInfo.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="结束时间" prop="endTime">
					<el-date-picker align="center" v-model="formInfo.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="是否显示" prop="showFlag">
					<el-radio-group v-model="formInfo.showFlag">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="规则说明" prop="voteRule">
					<el-input :rows="6" type="textarea" clearable placeholder="在此描述投票规则"
						v-model="formInfo.voteRule"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button class="confirm-btn" size="mini" type="primary" @click="toConfirm">下一步</el-button>
					<!-- <el-button class="cancel-btn" size="mini">取消</el-button> -->
				</el-form-item>
			</el-form>
		</div>
		<!--第二步-->
		<div class="step2" v-else>
			<el-button size="mini" type="primary" @click="selectPlayer">选择参赛者</el-button>
			<el-table border :data="votePlayerList" style="width: 100%; margin: 20px 0">
				<el-table-column prop="voteNo" label="投票号" width="120">
				</el-table-column>
				<el-table-column prop="playerName" label="姓名" width="150">
				</el-table-column>
				<el-table-column prop="schoolName" label="学校">
				</el-table-column>
				<el-table-column prop="voteCount" label="票数" width="120">
				</el-table-column>
				<el-table-column prop="voteTime" label="操作">
					<template slot-scope="scope">
						<span class="link-txt" @click="deletePlayer(scope.row)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-button size="mini" type="primary" @click="toPrev">上 一 步</el-button>
		</div>
		<!--选择参选者弹窗-->
		<el-dialog title="选择参选者" :visible.sync="dialogSelVisible" width="70%">
			<el-form :inline="true" class="dialog-form">
				<el-form-item label="姓名">
					<el-input v-model="userName" placeholder="请输入名称"></el-input>
				</el-form-item>
				<el-form-item label="人员范围">
					<el-select v-model="vacationId" placeholder="活动区域" @change="setSelectedAct">
						<el-option :label="item.vacationName" v-if="item.publishStatus==1" v-for="item in activityList" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
					<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
				</el-form-item>
			</el-form>
			<el-table border @selection-change="handleSelectionChange" :data="entrollList" style="width: 100%">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="userName" label="姓名">
				</el-table-column>
				<el-table-column prop="school" label="学校">
				</el-table-column>
				<el-table-column prop="grade" label="年级">
				</el-table-column>
				<el-table-column prop="major" label="专业">
				</el-table-column>
			</el-table>
			<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
			<div class="player-button">
				<el-button size="mini" type="primary" @click="toSubmitPlayer">提交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam, config } from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	import moment from 'moment'
	export default {
		name: 'AddSelection',
		components: {
			Title,
			Pagination
		},
		data() {
			return {
				stepIndex: 0,
				uploadUrl: '',
				dialogImageUrl: '',
				dialogVisible: false,
				dialogSelVisible: false,
				disabled: false,
				pageSize: 10,
				pageNum: 1,
				total: 0,
				posterList: [],   //logo图片回显示
				formInfo: {
					id: '', //投票id,修改时用
					vacationId: '', //投票的活动id
					status: 0, //0草稿 
					voteName: '', //单位名称
					startTime: '',
					endTime: '',
					showFlag: '1',
					poster: '',
					voteRule: '',
					coverUrl: '',
					coverId: '',
					voteType: 2 //投票类型 2公司系统投票  3活动投票
				},
				votePlayerList: [],
				entrollList: [],
				vacationId: '', //选择参赛者选择活动活动
				voteId: '',
				playerIds: '', //选择参选者id
				userName: '',
				activityList: [],
				rules: {
					voteName: [{
						required: true,
						message: '请输入投票名称',
						trigger: 'blur'
					}],
					startTime: [{
						required: true,
						message: '请选择开始时间',
						trigger: 'blur'
					}],
					endTime: [{
						required: true,
						message: '请选择结束时间',
						trigger: 'blur'
					}],
					logo: [{
						required: true,
						message: '请上传logo',
						trigger: 'blur'
					}],
					voteRule: [{
						required: true,
						message: '规则说明',
						trigger: 'blur'
					}]
				}
			}
		},
		created(){
			this.uploadUrl = config.baseUrl + 'admin/sys/upload'
			if(this.$route.query.vacationId) {
				this.formInfo.vacationId = this.$route.query.vacationId
				this.formInfo.voteType = 3
			}
			if(this.$route.query.id) {
				//有活动id 说明是修改活动
				this.formInfo.id = this.$route.query.id
				this.getDetailData()
			}
		},
		methods: {
			//获取投票详情
			async getDetailData() {
				let param = {
					id: this.formInfo.id
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/detail', qs.stringify(param))
				let entity = res.data.entity
				this.formInfo.voteName = entity.voteName
				this.formInfo.startTime = moment(new Date(entity.startTime * 1000)).format('YYYY-MM-DD HH:mm:ss')
				this.formInfo.endTime = moment(new Date(entity.endTime * 1000)).format('YYYY-MM-DD HH:mm:ss')
				this.formInfo.showFlag = entity.showFlag
				this.formInfo.voteRule = entity.voteRule
				this.posterList.push({
					url: entity.coverUrl
				})
				this.formInfo.coverId = entity.coverId
			},
			//切换进度步骤
			changeSteps(index){
				if(this.voteId){
					if(index==0) {
						//显示第一步
						this.stepIndex = 0
					} else {
						//显示第二步
						this.stepIndex = 1
					}
				} else{
					return
				}

			},
			//第一步提交
			toConfirm(){
				this.$refs.ruleForm.validate( async valid =>{
					if(valid){
						if(this.formInfo.coverId==''){
							this.$message.error('请上传投票封面')
							return
						}
						this.formInfo.startCompanyId=localStorage.getItem('companyId'),
						//提交
						console.log(this.formInfo)
						let param = this.formInfo
						ajaxParam(param)
						const res = await post('admin/voteInfo/save', qs.stringify(param))
						if(res.data.code==200){
							let id = res.data.entity.id
							this.voteId = id
							this.formInfo.id = id
							this.stepIndex = 1
							this.getVotePlayerList()
						} else {
							this.$message.error(res.data.msg)
						}
					}
				})
			},
			//获取参选者列表
			async getVotePlayerList(voteId) {
				let param = {
					voteId: this.voteId,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/votePlayerList', qs.stringify(param))
				let datalist = res.data.page.items
				this.votePlayerList = datalist
			},
			//删除参选者
			deletePlayer(row) {
				this.$confirm('确定要删除吗？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let param = {
						id: row.id
					}
					ajaxParam(param)
					const res = await post('admin/voteInfo/deletePlayer', qs.stringify(param))
					if(res.data.code==200){
						console.log('==============')
						console.log(this.votePlayerList)
						this.votePlayerList.forEach((item,index)=>{
							if(item.id==row.id){
								this.votePlayerList.splice(index,1)
							}
						})
					}
				}).catch(() => {

				})

			},
			//参选者弹窗
			selectPlayer(){
				this.dialogSelVisible = true
				this.getEntrollList()
				this.getActivityList()
			},
			//上一步
			toPrev() {
				this.stepIndex = 0
			},
			//获取选择参选者列表
			async getEntrollList() {
				let param = {
					startCompanyId: localStorage.getItem('companyId'),
					startCompanyName: localStorage.getItem('companyName'),
					voteId: this.voteId,
					voteType: this.formInfo.voteType,
					vacationId: this.formInfo.vacationId,
					userName: this.userName,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/enrollList', qs.stringify(param))
				let datalist = res.data.page.items
				this.entrollList = datalist
				this.total = res.data.page.count
			},
			//参选者选择和全选
			handleSelectionChange(val) {
				console.log(val)
				let arr = []
				val.forEach(item=>{
					arr.push(item.id)
				})
				this.playerIds = arr.join(',')
			},
			//提交保存参选者
			async toSubmitPlayer(){
				if(!this.playerIds){
					this.$message.error('请先选择一条记录！')
					return
				}
				let param = {
					voteId: this.voteId,
					playerIds: this.playerIds
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/savePlayers', qs.stringify(param))
				if (res.data.code == 200) {
					this.dialogSelVisible = false
					this.getVotePlayerList()
				}

			},
			//上传封面图片相关
			handleRemove(file) {
				console.log(file);
			},
			handleSuccess(res){
				let entity = res.entity
				this.formInfo.coverId = entity.id
				this.formInfo.coverUrl = entity.fileUrl
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			setSelectedAct(e){
				this.vacationId = e
				this.entrollList = []
				this.getEntrollList()
			},
			toSearch() {
				this.getEntrollList()
			},
			toReset() {
				this.vacationId = ''
				this.userName = ''
				this.pageNum = 1
				this.entrollList = []
				this.getEntrollList()
			},
			//获取活动列表
			async getActivityList(){
				let param = {
					startCompanyId: localStorage.getItem('companyId'),
					pageSize: 1000
				}
				ajaxParam(param)
				const res = await post('admin/vacation/list', qs.stringify(param))
				console.log(res.data.page.items)
				if (res.data.code == 200) {
					this.activityList = res.data.page.items
				}
			},
			//分页
			handleCurrentChange(e){
				this.entrollList = []
				this.pageNum = e.number
				this.getEntrollList()
			},
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}

	.steps {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px 0;

		.steps-list {
			display: flex;
			color: #323233;

			i {
				width: 24px;
				height: 24px;
				background: #EAEBEB;
				margin-right: 10px;
				border-radius: 50%;
				text-align: center;
				line-height: 24px;
			}

			span {
				opacity: .4;
			}
		}

		.steps-current {
			color: #EB6B1B;

			i {
				background-color: #EB6B1B;
				color: #fff;
			}

			span {
				opacity: 1;
			}
		}

		.steps-line {
			width: 160px;
			height: 2px;
			background: #EB6B1B;
			margin: 0 15px;
		}
	}

	.add-form {
		width: 60%;
		margin: 0 auto;

		.confirm-btn {
			width: 78px;
			background: #EB6B1B;
			border-color: #EB6B1B;
		}

		.cancel-btn:hover {
			color: #606266;
		}
	}
	.step2{
		width: 80%;
		margin: 0 auto;
	}
	.dialog-form{
		display: flex;
	}
	.player-button{
		display: flex;
		justify-content: flex-end;
		padding-top: 20px;
	}
	.link-txt{
		line-height: 26px;
		font-size: 12px;
		color: #EB6B1B;
	}
	/deep/ .el-form-item:last-of-type {
		display: flex;
		flex-direction: column;

		.el-form-item__label {
			text-align: left;
		}
	}
	/deep/ .el-upload-list--picture-card{
		display: inline-flex;
	}
	.upload-click{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 40px;
		line-height: 40px;
	}
	.upload-tips{
		margin: -16px 0 20px 100px;
		color: #EB1B1B;
		font-size: 12px;
	}
	/deep/ .el-dialog__body .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px!important;
	}
</style>
